import httpOp from "./axios/http-op";
import { withBrowserAuth } from "./browser-session";

class Op {
  constructor() {
    this.fetchOp = "/fetch-op";
    this.paymentSnapshot = "/payment-snapshot";
  }

  fetchOpList(refno, options = {}) {
    return httpOp.get(
      `${this.fetchOp}/${encodeURIComponent(refno)}`,
      withBrowserAuth(options),
    );
  }

  fetchPaymentSnapshot(billingNo, options = {}) {
    return httpOp.get(
      `${this.paymentSnapshot}/${encodeURIComponent(billingNo)}`,
      withBrowserAuth(options),
    );
  }
}

export default new Op();
